import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <main className="flex min-h-screen flex-col bg-linen">
      <header className="px-5 py-6 sm:px-8"><Logo /></header>
      <div className="flex flex-1 items-center justify-center px-5 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="w-full max-w-md rounded-[2rem] border border-ink/10 bg-white p-10 text-center shadow-2xl shadow-espresso/10"
          data-testid="payment-cancel-page"
        >
          <h1 className="font-serif text-2xl text-ink">Nessun problema.</h1>
          <p className="mt-4 text-sm leading-relaxed text-taupe">
            Il pagamento è stato annullato e non ti è stato addebitato nulla.
            La tua prima ora di libertà ti aspetta quando sei pronta.
          </p>
          <Link
            to="/"
            data-testid="cancel-back-home-button"
            className="mt-8 inline-block rounded-full bg-terracotta px-8 py-4 text-sm font-semibold text-linen shadow-lg shadow-terracotta/25 transition-all hover:bg-terracotta-dark"
          >
            Torna alla pagina
          </Link>
        </motion.div>
      </div>
    </main>
  );
}
